import { combineReducers } from '@reduxjs/toolkit';

import { areasOfFocusReducer as areasOfFocus } from './ducks/areasOfFocus';
import { contentsReducer as contents } from './ducks/contents';
import { currentUserReducer as currentUser } from './ducks/currentUser';
import { errorReducer as error } from './ducks/error';
import { flashMessagesReducer as flashMessages } from './ducks/flashMessages';
import { gMapsErrorReducer as gMapsError } from './ducks/gMapsError';
import { gradSchoolsReducer as gradSchools } from './ducks/gradSchools';
import { internshipFunctionsReducer as internshipFunctions } from './ducks/internshipFunctions';
import { invitesReducer as invites } from './ducks/invites';
import { invoicesReducer as invoices } from './ducks/invoices';
import { jobFunctionsReducer as jobFunctions } from './ducks/jobFunctions';
import { layoutReducer as layout } from './ducks/layout';
import { listingsReducer as listings } from './ducks/listings';
import { mainSearchReducer as mainSearch } from './ducks/mainSearch';
import { modalReducer as modal } from './ducks/modal';
import { orgDashboardReducer as orgDashboard } from './ducks/orgDashboard';
import { paymentMethodsReducer as paymentMethods } from './ducks/paymentMethods';
import { postSearchReducer as postSearch } from './ducks/postSearch';
import { searchRadiusReducer as searchRadius } from './ducks/searchRadius';
import { subscribedSubsitesReducer as subscribedSubsites } from './ducks/subscribedSubsites';
import { userLocationReducer as userLocation } from './ducks/userLocation';
import { userNotificationsReducer as userNotifications } from './ducks/userNotifications';
import { volopFunctionsReducer as volopFunctions } from './ducks/volopFunctions';
import { reducer as orgs } from './slices/orgs';

const reducers = {
  error,
  gMapsError,
  currentUser,
  userNotifications,
  userLocation,
  paymentMethods,
  invites,
  areasOfFocus,
  jobFunctions,
  internshipFunctions,
  volopFunctions,
  orgs,
  listings,
  mainSearch,
  modal,
  layout,
  searchRadius,
  flashMessages,
  orgDashboard,
  invoices,
  contents,
  postSearch,
  gradSchools,
  subscribedSubsites,
};

export const mainRootReducer = combineReducers(reducers);
